import View from './view';

const params = {
	adder: null,
	adderSelector: '[data-cloner="add"]',
	remover: null,
	removerSelector: '[data-cloner="remove"]',
	target: null,
	targetSelector: '[data-cloner="target"]',
	before: null,
	beforeSelector: '[data-cloner="before"]',
	first: 0,
	pattern: /0/g,
};

const removeEvent = new CustomEvent('cloneRemove', {bubbles: true});

export default class Cloner extends View {
	constructor(options) {
		super(options, params);

		this.clone = null;
		this.params.adder = this.params.adder
			|| this.el.query(this.params.adderSelector);
		this.params.remover = this.params.remover
			|| this.el.query(this.params.removerSelector);
		this.params.before = this.params.before
			|| this.el.query(this.params.beforeSelector);
		this.clones = this.el.queryAll(this.params.targetSelector);
		this.params.target = this.params.target
			|| this.clones[0];
		this.current = this.params.first + this.clones.length - 1;
	}

	start() {
		super.start();
		this.onChange();
	}

	initEvents() {
		super.initEvents();

		this.params.adder.addEventListener('click', this.onAdderClick.bind(this));
		this.params.remover.addEventListener('click', this.onRemoverClick.bind(this));

		this.events.on('insert', this.onInsert.bind(this));
		this.events.on('remove', this.onRemove.bind(this));
		this.events.on('changed', this.onChange.bind(this));
	}

	setClone() {
		const frag = document.createDocumentFragment();
		const node = this.params.target.cloneNode(true);
		frag.appendChild(node);
		this.clone = frag;
		this.events.emit('clone', this.clone);
	}

	getClone() {
		if (!this.clone) {
			this.setClone();
		}

		let clone = this.clone;
		this.current++;
		if (this.params.pattern) {
			let str = this.frag2string(clone);
			str = str.replace(this.params.pattern, this.current);
			clone = this.string2frag(str);
		}
		return clone;
	}

	insert(frag) {
		const node = frag.firstChild;
		if (this.params.before) {
			this.insertBefore(frag, this.params.before);
		}
		/*
		 else {
		 // TODO
		 }
		 */
		this.clones.push(node);
		this.events.emit('insert', node);
	}

	insertBefore(frag, before) {
		this.el.insertBefore(frag, before);
	}

	remove() {
		const node = this.clones[this.clones.length - 1];
		node.parentNode.removeChild(node);
		this.clones.pop();
		this.current--;
		this.events.emit('remove');
	}

	showRemover() {
		this.params.remover.classList.remove('hidden');
	}

	hideRemover() {
		this.params.remover.classList.add('hidden');
	}

	//  EVENTS

	onAdderClick(event) {
		event.preventDefault();

		const clone = this.getClone();
		this.insert(clone);

		return false;
	}

	onRemoverClick(event) {
		event.preventDefault();

		this.remove();

		return false;
	}

	onInsert(node) {
		this.events.emit('changed');
		let event = new CustomEvent('cloneAdd', {bubbles: true, detail: {clone: node}});
		this.el.dispatchEvent(event);
	}

	onRemove() {
		this.events.emit('changed');
		this.el.dispatchEvent(removeEvent);
	}

	onChange() {
		if (this.current > this.params.first) {
			this.showRemover();
		} else {
			this.hideRemover();
		}
	}


	// UTILS

	frag2string(frag) {
		const div = document.createElement('div');
		div.appendChild(frag.cloneNode(true));
		return div.innerHTML;
	}

	string2frag(str) {
		const frag = document.createDocumentFragment();
		const div = document.createElement('div');
		div.innerHTML = str;
		while (div.firstChild) {
			frag.appendChild(div.firstChild);
		}
		return frag;
	}
}

// Init all cloners
document.queryAll('.slx-cloner').forEach(el => new Cloner({el}).start());
